var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-wrapper"},[_c('div',{staticClass:"spinner-wrapper"},[_c('spinner',{staticClass:"spinner"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }